module.exports = __webpack_public_path__ + "assets/img/sabc_social_facebook.svg?49821a75bfdfbf84aed18d778b870f81";